import React from 'react';
import classNames from 'classnames';
import AnimateNumber from '@alife/bc-animate-number';

export default function Total(props) {
  const { show, totalCost, logisticsIsEmpty, i18n = {} } = props;

  return (
    <div
      className={classNames({
        'sub-total-area': true,
        show,
      })}
    >
      <span className="split-line split-line-show" />
      <span className="sub-item-name">{i18n['rightAction.total']}</span>
      <span
        className={
          logisticsIsEmpty
            ? 'sub-item-right sub-item-right-small'
            : 'sub-item-right'
        }
      >
        {!logisticsIsEmpty && <AnimateNumber value={totalCost} />}
        {logisticsIsEmpty && 'To Be Negotiated'}
      </span>
    </div>
  );
}
